import React from "react";

const SectionHeaders = ({ title, className }) => {
  return (
    <div className={`text-3xl font-semibold text-center  mb-4 ${className}`}>
      {title}
    </div>
  );
};

export default SectionHeaders;
